import { useNavigate } from "react-router-dom";
import { ArrowUpRight, Mail } from "lucide-react";
import { Eyebrow, Reveal } from "../lib/ui";

export const ContactSection = () => {
  const navigate = useNavigate();

  return (
    <section
      data-testid="contact-cta"
      className="border-t border-slate-200 bg-slate-50/60 py-20 sm:py-24"
    >
      <div className="mx-auto grid max-w-[1440px] items-end gap-10 px-6 sm:px-8 lg:grid-cols-12 lg:px-12">
        <Reveal className="lg:col-span-7">
          <Eyebrow>Kontakt</Eyebrow>
          <h2
            data-testid="contact-cta-heading"
            className="mt-3 text-3xl font-semibold tracking-[-0.02em] text-slate-900 sm:text-4xl"
          >
            Har du en juridisk problemstilling?
          </h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-600">
            Fortæl os om din sag i fem nemme trin — det tager under to minutter, og så
            kontakter vi dig med næste skridt. Du får altid en kopi af din henvendelse på
            e-mail.
          </p>
        </Reveal>

        <Reveal delay={0.1} className="lg:col-span-5">
          <div className="flex flex-col items-start gap-5 lg:items-end">
            <button
              type="button"
              data-testid="contact-cta-button"
              onClick={() => navigate("/kontakt")}
              className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-950 px-8 py-4 text-base font-semibold text-white shadow-lg shadow-brand-950/30 transition-all duration-200 hover:bg-brand-900"
            >
              Start din henvendelse
              <ArrowUpRight className="h-4 w-4" />
            </button>
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
              <span className="flex items-center gap-2 text-slate-700">
                <Mail className="h-4 w-4 text-brand-600" />
                <a
                  href="mailto:kontakt@juris.dk"
                  data-testid="contact-cta-email"
                  className="font-medium hover:text-brand-600"
                >
                  kontakt@juris.dk
                </a>
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ContactSection;
